import React from "react";
import Link from "./link";
import { FormattedMessage } from "react-intl";

const PrivatisationBanner = () => {
  return (
    <section className="privatisation-banner">
      <div className="container">
        <div>
          <h2
            id="privatisation-banner-heading"
            className="heading heading-large"
          >
            <span>
              <FormattedMessage id="privateBannerTitle" />
            </span>
          </h2>
          <p>
            <FormattedMessage id="privateBannerText" />
          </p>
        </div>
        <Link
          href="/contact"
          button="_blank"
          className="privatisation-banner-button button-ghost"
        >
          <FormattedMessage id="privateBannerCTA" />
        </Link>
      </div>
    </section>
  );
};

export default PrivatisationBanner;
